import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slider from '@mui/material/Slider';
import AddIcon from '@mui/icons-material/AddRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import {countries} from '../../../utils/References';
import { useSelector, useDispatch } from 'react-redux'
import endpoints, { apiRequest } from '../../../endpoints';
import { fullHeightModalResize } from '../../../utils/Utils';

const defaultWorkTime = [
    {name: 'SU', enable: true, ranges: [[0,24],]},
    {name: 'MO', enable: true, ranges: [[0,24],]},
    {name: 'TU', enable: true, ranges: [[0,24],]},
    {name: 'WE', enable: true, ranges: [[0,24],]},
    {name: 'TH', enable: true, ranges: [[0,24],]},
    {name: 'FR', enable: true, ranges: [[0,24],]},
    {name: 'SA', enable: true, ranges: [[0,24],]},
]

const dayHours = [
    {value: 0, label: '0:00'},
    {value: 4, label: '4:00'},
    {value: 8, label: '8:00'},
    {value: 12, label: '12:00'},
    {value: 16, label: '16:00'},
    {value: 20, label: '20:00'},
    {value: 24, label: '0:00'},
]

let data = null;

export default function AutoreplySettingsModal(props) {
    if (props.data) {
        data = props.data;
    }
    
    const [workTime, setWorkTime] = useState(null)
    const [excludeCountries, setExcludeCountries] = useState([])
    const [templateBody, setTemplateBody] = useState('')
    const [templateLinks, setTemplateLinks] = useState('')
    const [topics, setTopics] = useState('')
    const [updateCounter, setUpdateCounter] = useState(0)
    
    const [tab, setTab] = useState(0)
    if (props.data == null && tab != 0) {
        setTab(0)
    }
    
    const token = useSelector((state) => state.auth.token)
    
    const tabChange = (event, newValue) => {
        setTab(newValue);
    };
    
    const getWorkTime = async () => {
        try {
            const res = await apiRequest('get', endpoints.settings,{
                token: token,
                name: 'AUTOREPLY_EMAIL_TIME',
            })
            
            if (res.data.value) {
                setWorkTime(JSON.parse(res.data.value))
            } else {
                setWorkTime(defaultWorkTime)
            }
        } catch (e) {
            //
        }
    }
    
    const getCountries = async () => {
        try {
            const res = await apiRequest('get', endpoints.settings,{
                token: token,
                name: 'AUTOREPLY_EMAIL_COUNTRIES',
            })
            
            if (res.data.value) {
                setExcludeCountries((res.data.value || '').split(';'))
            } else {
                setExcludeCountries([])
            }
        } catch (e) {
            //
        }
    }
    
    const getTemplates = async () => {
        try {
            // ------------------------------
            const res = await apiRequest('get', endpoints.settings,{
                token: token,
                name: 'AUTOREPLY_TEMPLATE_BODY',
            })
            
            if (res.data.value) {
                setTemplateBody(res.data.value || '')
            } else {
                setTemplateBody('')
            }
            // ------------------------------
            const res2 = await apiRequest('get', endpoints.settings,{
                token: token,
                name: 'AUTOREPLY_TEMPLATE_LINKS',
            })
            
            if (res2.data.value) {
                setTemplateLinks(res2.data.value || '')
            } else {
                setTemplateLinks('')
            }
            // ------------------------------
        } catch (e) {
            //
        }
    }
    
    const getTopics = async () => {
        try {
            const res = await apiRequest('get', endpoints.settings,{
                token: token,
                name: 'AUTOREPLY_TOPICS',
            })
            
            if (res.data.value) {
                setTopics(res.data.value)
            } else {
                setTopics('')
            }
        } catch (e) {
            //
        }
    }
        
    const save = async () => {
        try {
            await apiRequest('put', endpoints.settings, {
                token: token,
                name: 'AUTOREPLY_EMAIL_TIME',
                value: JSON.stringify(workTime),
            });
            
            await apiRequest('put', endpoints.settings, {
                token: token,
                name: 'AUTOREPLY_EMAIL_COUNTRIES',
                value: excludeCountries.join(';')
            });
            
            await apiRequest('put', endpoints.settings, {
                token: token,
                name: 'AUTOREPLY_TEMPLATE_BODY',
                value: templateBody
            });
            
            await apiRequest('put', endpoints.settings, {
                token: token,
                name: 'AUTOREPLY_TEMPLATE_LINKS',
                value: templateLinks
            });
            
            await apiRequest('put', endpoints.settings, {
                token: token,
                name: 'AUTOREPLY_TOPICS',
                value: topics
            });
        } catch (e) {
            //
        }
        props.onClose()
    }
    
    useEffect(() => {
        getWorkTime()
        getCountries()
        getTemplates()
        getTopics()
    }, [props.data])
    
    const resize = () => {
        fullHeightModalResize()
    }
    
    useEffect(() => {
        fullHeightModalResize()
    }, [tab])
    
    useEffect(() => {
        fullHeightModalResize()
        
        window.removeEventListener('resize', resize)
        window.addEventListener('resize', resize)
    }, [])
        
    return (
        <Dialog open={props.data ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="sm" >
            <DialogTitle id="alert-dialog-title">
                <Stack spacing={1.5}>
                    Settings
                    <IconButton
                        onClick={props.onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Box sx={{ width: '100%', marginBottom: 2 }}>
                        <Tabs value={tab} onChange={tabChange}>
                            <Tab value={0} label="General" />
                            <Tab value={1} label="Work Time" />
                            <Tab value={2} label="Templates" />
                            <Tab value={3} label="Topics" />
                        </Tabs>
                    </Box>
                </Stack>
            </DialogTitle>
            <DialogContent 
                className="dialogContentFullHeight" 
                sx={{display: 'flex', flexDirection: 'column'}}
            >
                <Stack spacing={2} sx={(tab == 0 ? {flexGrow:1} : {display: 'none'})}>
                    <FormControl variant="filled" fullWidth>
                        <InputLabel id="countiesLabel">Exclude Countries</InputLabel>
                        <Select
                            fullWidth
                            labelId="countiesLabel"
                            label="Exclude Countries"
                            value={excludeCountries}
                            onChange={(e) => setExcludeCountries(e.target.value)}
                            multiple
                            variant="filled"
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected?.map((value) => (
                                        <Chip key={value} label={value} size="small"/>
                                    ))}
                                </Box>
                            )}
                            sx={{'& div': {maxHeight: '90px', overflow: 'auto'} }}
                        >
                            {countries?.map((row) => (
                                <MenuItem key={row} value={row} sx={{p:0, pl:1, pr:1}}>
                                    <Checkbox checked={excludeCountries?.indexOf(row) > -1} />
                                    <ListItemText primary={row} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack spacing={0} sx={(tab == 1 ? {flexGrow:1} : {display: 'none'})}>
                    <Stack className="dialogFieldFullHeight" sx={{pt:2}}>
                        {workTime?.map((day, index) => {
                        return (
                            <Stack 
                                key={index}
                                direction="row" 
                                sx={{borderBottom: '1px solid #dddddd', '&:last-child': {border:0} }}
                                spacing={0.75}
                            >
                                <Stack alignItems="center" sx={{pt: 2, pr:1, minWidth: 4, borderRight: '1px solid #dddddd'}}>
                                    <b>{day.name}</b>
                                    <FormControlLabel
                                        sx={{m:0}}
                                        control={
                                            <Switch 
                                                color="primary" 
                                                size="small" 
                                                checked={day.enable}
                                                onChange={(e) => {
                                                    day.enable = e.target.checked
                                                    setUpdateCounter(updateCounter + 1)
                                                }} 
                                            />
                                        }
                                        labelPlacement="bottom"
                                    />
                                </Stack>
                                <Stack sx={{flexGrow:1, p:2, pb:1.5, pr:0, opacity: day.enable ? 1 : 0.5, }}>
                                    {day.ranges.map((range, index) => {
                                    return (
                                        <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{pl:2}}>
                                            <Slider
                                                value={range}
                                                onChange={(e, newValue) => {
                                                    range[0] = newValue[0]
                                                    range[1] = newValue[1]
                                                    setUpdateCounter(updateCounter + 1)
                                                }}
                                                valueLabelDisplay="auto"
                                                valueLabelFormat={(value) => {
                                                    let h = Math.floor(value)
                                                    let m = Math.floor(60 * (value - h))
                                                    if (m === 0) {
                                                        m = '00'
                                                    }
                                                    if (h === 24 && m === '00') {
                                                        h = '0'
                                                    }
                                                    return h + ':' + m
                                                }}
                                                sx={{mt:0.3}}
                                                step={0.25}
                                                min={0}
                                                max={24}
                                                marks={dayHours}
                                            />
                                            <IconButton 
                                                size="small"
                                                onClick={() => {
                                                    day.ranges.splice(index, 1)
                                                    setUpdateCounter(updateCounter + 1)
                                                }}
                                                disabled={day.ranges.length > 1 ? false : true}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Stack>
                                        )
                                    })}
                                    <Stack direction="row">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => {
                                                day.ranges.push([0,24])
                                                setUpdateCounter(updateCounter + 1)
                                            }}
                                            sx={{mt: 0.75, p: '2px 14px'}}
                                        >
                                            Add Range
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                            )
                        })}
                    </Stack>
                </Stack>
                <Stack spacing={2} sx={(tab == 2 ? {flexGrow:1} : {display: 'none'})}>
                    <TextField
                        fullWidth
                        name="templateBody" 
                        label="Email Body" 
                        variant="filled"
                        multiline
                        rows={7}
                        defaultValue={templateBody}
                        onChange={(e) => {setTemplateBody(e.target.value)}}
                        helperText="Use Tags: {name}, {links}"
                    />
                    <TextField
                        fullWidth
                        name="templateLinks" 
                        label="Link List Title" 
                        variant="filled"
                        multiline
                        rows={4}
                        defaultValue={templateLinks}
                        onChange={(e) => {setTemplateLinks(e.target.value)}}
                    />
                </Stack>
                <Stack spacing={2} sx={(tab == 3 ? {flexGrow:1} : {display: 'none'})}>
                    <TextField
                        fullWidth
                        className="textareaFullHeight"
                        name="topics" 
                        label="Topics" 
                        variant="filled"
                        multiline
                        rows={10}
                        defaultValue={topics}
                        onChange={(e) => {setTopics(e.target.value)}}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose(false)}}>Cancel</Button>
                <Button onClick={save} autoFocus>Save</Button>
            </DialogActions>
        </Dialog>
    )
}